<template>
	<p class="vue-component component-error-notice">
		Sorry, could not load user interface from server. Please try again.
	</p>
</template>

<script>
export default {
	name: 'Errored'
}
</script>